// 土耳其语
export default {
  day: 'gün',
  hour: 'saat',
  min: 'dakika',
  sesc: 'saniye',
  cancel: 'iptal',
  confirm: 'onayla',
  showMore: 'daha fazla göster',
  hideMore: 'daha az göster',
  per_sale: { 
    title: 'Ön satış aşaması {days} gün {hours} saat {mins} dakika {secs} saniye sonra sona eriyor',
    title1: 'Public Sale\'e katılmak için önce KYC\'yi tamamlamak gerekiyor',
    text: 'DLC satın al',
    text1: 'KYC\'ye katıl',
  },
  meau: {
    nav1: 'DeepLink nedir?',
    nav2: 'Nasıl satın alınır?',
    nav3: 'Beyaz Kitap',
    nav4: 'PITCH DECK',
    nav5: 'FAQ',
    nav6: 'Research',
    add: 'Adres:',
    link: 'Cüzdanı bağla',
  },
  home: {
    intro: {
      title: 'DeepLink Public Sale',
      text: 'Birinci aşama açık satış için geri sayım:',
      text1: 'Mevcut KYC başlatıldı',
      text2: 'Halka Açık Satış 5. Aşamanın Bitimine Geri Sayım',
      text3: 'İkinci aşama açık satış için geri sayım:',
      tip: 'Lütfen (DLC) tokenlerini satın almadan önce KYC doğrulamasını tamamladığınızdan emin olun',
      tip1: 'Yinelenen satın alma yapmayın',
    },
    desc: {
      title: 'Deeplink iki bileşenden oluşur: DeepLink Protocol ve Deeplink Software',
      left: {
        text: 'Tüm ödemeler DeepLink tokenleri ile yapılır!',
        text1: 'DeepLink Protocol, merkezi olmayan bir AI bulut oyun protokolüdür,',
        text2: 'AI ve blockchain teknolojisini birleştirerek ultra düşük gecikmeli oyun render teknolojisi sağlar. DeepLink Software, DeepLink Protocol üzerinde geliştirilen bir oyun uzaktan kontrol yazılımı ve bulut oyun platformudur. DeepLink Protocol temelinde geliştirilen diğer ürünler arasında bulut internet kafe platformu, blockchain bulut oyun makinesi, blockchain bulut oyun el konsolu ve diğer ürünler bulunmaktadır.',
        text3: '100% Secure & Verified',
        btn1: 'DeepLink Protocol Tanıtımı',
        btn2: 'DeepLink Software Tanıtımı',
      },
      right: {
        text1: 'Public Sale devam ediyor',
        text1_1: 'KYC devam ediyor',
        text1_2: 'Public Sale Aşama {pre_num1} devam ediyor',
        // text2: 'DLC fiyatı: 1DLC={price}USDT, kalan {days} gün {hour} saat {min} dakika',
        text2: 'DLC fiyatı: 1DLC={price}USDT',
        text3: '{pre_num}. Public Sale sona erdi',
        text4: 'Aşama {pre_num1} başlamak üzere',
        text5: 'Public Sale başlamak üzere',
        text6: 'Lütfen açık satışa katılmadan önce KYC doğrulama sürecini tamamlayın. İşbirliğiniz için teşekkür ederiz.',
        // text7: "Mevcut aşamada %10 ek token ödülü, bir sonraki aşamada ödül %5'a düşecek",
        text7: 'Mevcut aşamada %5 ek token ödülü, bir sonraki aşamada ek ödül yok',
        text8: 'Topluluğa katılın ve 10,000 USDT ve DLC kazanma çekilişine katılın',
        process: 'Tamamlandı {process}%',
        btn1: 'KYC doğrulamasına katıl',
        btn1_1: 'KYC onaylandı',
        text7_1: 'Mevcut cüzdanın KYC\'si inceleniyor, lütfen bekleyin',
        text7_2: 'Mevcut cüzdanın KYC\'si onaylandı!',
        text7_3: 'Mevcut cüzdanın KYC\'si onaylanmadı, lütfen yeniden gönderin!',
        text7_4: 'Mevcut cüzdanın KYC\'si gönderilmedi',
        btn2: 'DLC TOKEN satın al',
        btn3: '5% tavsiye bağlantısı',
        btn3_1: '10% tavsiye bağlantısı',
        btn3_2: '15% tavsiye bağlantısı',
        btn3_3: '20% tavsiye bağlantısı',
      },
      success: 'Bağlantı panoya kopyalandı',
      error1: 'Özel davet kodunu almak ve ödüller kazanmak için lütfen önce cüzdanınızı bağlayın',
      error2: 'Cüzdan bağlı değil, lütfen önce cüzdanınızı bağlayın',
      error3: 'KYC doğrulaması devam ediyor, lütfen satın alma işlemini gerçekleştirmeden önce tamamlanmasını bekleyin',
      error4: 'KYC doğrulaması başarısız oldu, lütfen satın almak için KYC doğrulama bilgilerini yeniden gönderin',
      error5: 'KYC doğrulama bilgileri alınamadı, lütfen daha sonra tekrar deneyin',
      error6: 'Lütfen satın alma işlemini gerçekleştirmek için geri sayımın bitmesini bekleyin.',
      error7: "Aşama 3 sona erdi, lütfen Aşama 4'ün başlamasını bekleyin",
      tip1: 'DLC henüz dağıtılmadı',
      tip2: 'DLC kullanıcının cüzdanına dağıtıldı',
      tip3: 'Ödeme başarılı',
    },
    rule: {
      title: 'Kural Açıklaması',
      text1: 'KYC doğrulaması zorunludur ve kimlik kartı, pasaport veya ehliyet gibi kimlik belgelerinin sunulmasını gerektirir. Singapur, Çin, Amerika Birleşik Devletleri, Güney Kore ve bazı diğer ülkelerin sakinleri IDO\'ya katılamazlar.',
      text2: 'Açık satışın bitiminden sonra, DLC 7 gün içinde DEX borsalarında ve 15 gün içinde CEX borsalarında listelenecektir. BSC zincirindeki DLC tokenının akıllı sözleşme adresi: 0xD610Be30b06A3828A27D608a38F1E85faAFdEDcC',
      text3: '20,000,000 DLC satın almak, 1500 dolar değerinde bir DeepLink ev tipi GPU oyun madencilik makinesi kazanmanızı sağlar. Bu teklif yalnızca Japonya ve Avrupa ile sınırlıdır ve gönderim ayrıntıları e-posta yoluyla bildirilecektir.',
      text3_btn: 'Ev Tipi GPU Oyun Madencilik Makinesi hakkında daha fazla bilgi edinin',
      text4: 'Açık satış, başlatıldıktan 48 saat sonra kapanacaktır ve her DLC\'nin fiyatı 0.003 USDT\'dir. Tokenlerin %40\'ı kilitsiz kalacak, kalan %60\'ı ise 31 Ağustos 2024\'ten itibaren kademeli olarak açılacaktır. Dikkat edilmesi gereken husus şudur: DLC\'nin %40\'ı satın alımdan birkaç dakika sonra belirttiğiniz cüzdan adresine transfer edilecektir, kalan %60\'ı ise kilit süresi sona erdiğinde cüzdanınıza transfer edilecektir.',
      text5: 'Public Sale 5 aşamada gerçekleştirilecektir,',
      table: {
        table1_text1: 'aşama',
        table1_text2: '2024/06/05-06/07',
        table1_text3: '2024/06/09-06/29',
        table1_text4: '2024/06/29-07/13',
        table1_text5: '2024/07/13-08/05',
        table1_text6: '2024/08/05-09/11',
        table2_text1: 'DLC Miktarı',
        table2_text2: '350,000,000DLC',
        table2_text3: '400,000,000DLC',
        table2_text4: '300,000,000DLC',
        table2_text5: '450,000,000DLC',
        table2_text6: 'TBA',
        table3_text1: 'DLC Fiyatı (USDT)',
        table3_text2: '0.003',
        table3_text3: '0.003',
        table3_text4: '0.003',
        table3_text5: '0.003',
        table3_text6: '0.003',
        table4_text1: 'Bonus',
        table4_text2: 'Ekstra %20 DLC hediye',
        table4_text3: 'Ekstra %15 DLC hediye',
        table4_text4: 'Ekstra %10 DLC hediye',
        table4_text5: 'Ekstra %5 DLC hediye',
        table4_text6: 'NO',
        table5_text1: 'Miktar',
        table5_text2: '1,050,000 USDT',
        table5_text3: '1,200,000 USDT',
        table5_text4: '900,000 USDT',
        table5_text5: '1,350,000 USDT',
        table5_text6: 'TBA'
      }
    },
    ecology: {
      title: 'DeepLink Protocol Ekosistemine Genel Bakış',
      block1_title: 'DeepLink Yazılımı',
      block1_text1: 'DeepLink yazılımının ana işlevi uzaktan kontrol ve bulut oyun platformudur',
      block1_text2: 'DeepLink Protocol, DeepLink Protocol ve DeepLink Software\'i içerir. DeepLink Software\'in merkezinde, kullanıcılara uzaktan oyun, uzaktan çalışma ve bulut tabanlı oyun hizmetlerine erişim sağlama yetenekleri sunan uzaktan kontrol ve bulut oyun işlevleri bulunur. Şu anda, bu yazılım 110 ülkede kullanıcı tabanına sahip, 400.000\'den fazla indirme ve dünya genelinde 200.000\'den fazla oluşturulmuş cüzdan bulunmaktadır.',
      block1_btn1: 'DeepLink yazılımını öğrenin',
      block2_title: 'Bulut İnternet Kafeler ve Bulut eSpor',
      block2_text1: 'Bulut internet kafe, DeepLink Protocol\'ün ultra düşük gecikmeli render teknolojisini kullanarak internet kafe ve eSpor hizmetlerinin yenilikçi bir modelini temsil eder.',
      block2_text2: 'Bu yapılandırmada, oyunlar ve uygulamalar yerel bilgisayarlar yerine bulut GPU sunucularında barındırılır, kullanıcıların yüksek performanslı yerel GPU iş istasyonlarına ihtiyaç duymadan bulut hizmetleri aracılığıyla oyunlara erişmelerine ve oynamalarına olanak tanır. DeepLink teknolojisine dayalı bulut internet kafeler, HYCONS, ZESTCLOUD, GLOWSTEAM ve TIKEREN\'in katılımıyla Güney Kore, Çin, Japonya, Vietnam, Filipinler ve Hindistan gibi birçok ülkede dağıtılmaktadır. Güney Kore\'de zaten işletme örneği mevcuttur.',
      block2_btn1: 'Videoyu İzle',
      block2_btn2: 'Bulut internet kafeleri hakkında bilgi edinin',
      block3_title: 'Blokzincir tabanlı bulut oyun konsolu',
      block3_text1: 'Bulut oyun konsolu nedir?',
      block3_text2: 'Blokzincir tabanlı bulut oyun konsolu, oyun donanımında bir atılımı temsil eder ve kesintisiz bir eSpor oyun deneyimi için yüksek FPS yenileme hızı sunar. HKC grubu tarafından geliştirilen TIKEREN bulut oyun konsolu, DeepLink\'in ultra düşük gecikmeli render teknolojisini kullanır ve oyun render performansını artırmak için gerçek zamanlı olarak bulut GPU sunucularına bağlanır.',
      block3_btn1: 'Blokzincir tabanlı bulut oyun konsolu hakkında bilgi edinin',
      block4_title: 'Blokzincir tabanlı bulut oyun el konsolu',
      block4_text1: 'Bulut oyun el konsolu nedir?',
      block4_text2: 'DeepLink\'in ultra düşük gecikmeli render teknolojisine dayanan bulut oyun el konsolu, geleneksel el konsollarına kıyasla daha uygun maliyetli bir seçenek sunar ve aynı zamanda akıcı bir AAA oyun deneyimi sağlar. Gerçek zamanlı oyun render işlemi için bulut GPU sunucularına bağlanarak, el konsolu maliyetini %70 oranında azaltır.',
      block4_btn1: 'Blokzincir tabanlı bulut oyun el konsolu hakkında bilgi edinin',
    },
    coverage: {
      title: 'DeepLink yazılımı küresel kullanıcı dağılım haritası',
      text: 'Toplam DeepLink Kullanıcı Sayısı:'
    },
    track: {
      title: 'DeepLink Protocol, DePIN+AI+Game birleşimidir',
      text: 'Mevcut blockchain endüstrisinin en popüler alanlarından biridir',
      block1_title: 'DeepLink pazarının büyüklüğü ne kadar?',
      block1_text: 'DeepLink\'in işlevlerinden biri, merkezi olmayan bir XBOX ve PlayStation olarak anlaşılabilir. 2023 yılının sonuna kadar Sony\'nin PS5\'inin dünya çapındaki satışları 50 milyon adede, Xbox Series X|S\'in ise 30 milyon adede ulaştı. PS ve Xbox\'un toplam satışları 200 milyondan fazla olup, yüksek kaliteli AAA oyun pazarının büyüklüğünü göstermektedir.',
      block2_title: 'DeepLink, XBOX ve PlayStation gibi yüksek kaliteli AAA oyun oyuncularına hizmet vermektedir, ancak iş modeli tamamen farklıdır',
      block2_text: 'DeepLink oyuncularının yüksek kaliteli oyun konsolları satın almasına gerek yoktur. Sadece DeepLink yazılımını indirmeleri veya blockchain tabanlı bir bulut oyun konsolu veya blockchain tabanlı taşınabilir bir bulut oyun konsolu satın almaları yeterlidir. Oyuncular, XBOX ve PlayStation gibi AAA oyun deneyimi yaşarken, donanım maliyetlerinin %80\'ini tasarruf ederler.',
      block3_title: 'Madenciler, yüksek kaliteli AAA oyun konsolları sağlar, bu konsollar Windows sistemleridir ve tüm Windows AAA oyunları ile uyumludur.',
      block3_text: 'Madencilerin oyun konsolları evde veya veri merkezlerinde olabilir. Xbox ve PlayStation konsolları sadece sahipleri tarafından kullanılabilir ve başkalarına kiralanamaz, bu da düşük kullanım verimliliğine ve büyük kaynak israfına yol açar. DeepLink\'in oyun madencilik makinesi herkesle paylaşılabilir, bu da donanım kaynaklarının kullanımını artırır ve yeni bir iş modeli sunar.',
      block4_title: 'Oyun madencilik makinesi sağlayan madenciler DLC token ödülleri alabilir',
      block4_text: 'Bu, daha fazla madencinin oyun madencilik makinesi sağlamasını teşvik eder. Kullanıcılar oyun süresi satın almak için DLC tokenları ile ödeme yapmalıdır, bu da DLC\'nin kullanım senaryolarını genişletir ve token sahibi sayısını artırır. Potansiyel kullanıcı pazarının büyüklüğü 1 milyardan fazla kişidir.',
      table: {
        table1_text1: 'Detaylı Karşılaştırma',
        table1_text2: 'Deep Link',
        table1_text3: 'Xbox',
        table1_text4: 'PS5',
        table2_text1: 'AAA oyunları oynamak',
        table2_text2: 'Kullanıcıların donanım satın almasına gerek yok, sadece DeepLink yazılımını indirmeleri gerekiyor',
        table2_text3: 'Kullanıcıların donanım satın alması gerekiyor',
        table2_text4: 'Kullanıcıların donanım satın alması gerekiyor',
        table3_text1: 'Oyun konsolu',
        table3_text2: '$DLC kazanmak için kiralanabilir, günde 12 saatten fazla kiralanabilir, 10 ayda amorti edilir',
        table3_text3: 'Sadece sahibinin kullanabileceği, kiralanamayacağı, günde 2-4 saat kullanılan, donanım kaynaklarının israf edildiği',
        table3_text4: 'Sadece sahibinin kullanabileceği, kiralanamayacağı, günde 2-4 saat kullanılan, donanım kaynaklarının israf edildiği',
        table4_text1: 'Taşınabilir konsol',
        table4_text2: 'Desteklenir, herhangi bir donanıma bağlanabilir',
        table4_text3: 'Özel taşınabilir konsolu yok',
        table4_text4: 'Desteklenir, sadece PS5\'e bağlanabilir',
        table5_text1: 'Bulut oyun konsolu',
        table5_text2: 'Desteklenir',
        table5_text3: 'Desteklenmez',
        table5_text4: 'Desteklenmez',
        table6_text1: 'Bulut internet kafe',
        table6_text2: 'Desteklenir',
        table6_text3: 'Desteklenmez',
        table6_text4: 'Desteklenmez',
      },
      btn1: 'DeepLink Software',
      btn2: 'DeepLink Protocol',
      btn3: 'Ekip Tanıtımı',
      btn4: 'Ekonomik Model'
    },
    faqs: {
      title: 'FAQS',
      text: 'Sorularınız olabilir, bizde cevaplar var.',
      ques_title1: '1. Public Sale nedir?',
      ques_text1: "Public Sale sırasında, belirli bir fiyattan sınırlı sayıda token, erken aşamada katılmak isteyen kişilere satılacaktır. Bu, tokenların gerçek lansmanından önce DeepLink'in bir parçası olma fırsatıdır. Public Sale'e katılarak, tokenları halka arzdan önce erken bir fiyattan satın alabilirsiniz. Bu nedenle, Public Sale, tokenların dolaşıma girmesi ve borsalarda listelenmesinden önce satın alma fırsatı olarak değerlendirilebilir.",
      ques_title2: '2. Neden Public Sale düzenliyoruz?',
      ques_text2_1: 'Güçlü bir $DLC sahipleri topluluğu oluşturmak, platformumuzu geliştirmek ve ekosistemimize daha fazla oyuncu çekmek için Public Sale düzenliyoruz.',
      ques_text2_2: 'Public Sale sırasında toplanan fonlar sürekli olarak DeepLink ürünlerine yeniden yatırılacak, yeni özellikler tanıtılacak ve pazarlama faaliyetleriyle kullanıcı tabanı genişletilecektir. Bu, $DLC Token lansmanından önce pazar tanıtım stratejimizi uygulamamızı sağlayacaktır.',
      ques_text2_3: "Amacımız 1.000.000.000 kişinin DeepLink kullanmasını sağlamak, bu da $DLC Token'ın geniş kullanım senaryoları yaratacak ve $DLC Token'ın uzun vadeli başarısını sağlayacaktır. $DLC Token DEX ve CEX borsalarında listelenecek ve bu da DeepLink ekosisteminin büyümesini daha da hızlandıracaktır.",
      ques_text2_4: "Hemen DeepLink Public Sale'e katılın ve DeepLink'in bir parçası olun!",
      ques_title3: '3. DeepLink Protocol ile DeepLink Software arasındaki fark nedir?',
      ques_text3_1: 'DeepLink Protocol, AI ve blockchain teknolojilerini birleştirerek ultra düşük gecikmeli oyun render teknolojisi sağlayan merkezi olmayan bir AI bulut oyun protokolüdür.',
      ques_text3_2: 'DeepLink Software, DeepLink Protocol üzerine kurulu bir oyun uzaktan kontrol yazılımı ve bulut oyun platformudur.',
      ques_text3_3: 'DeepLink Protocol üzerine kurulu diğer ürünler arasında bulut eSpor kafe platformu, blockchain tabanlı bulut oyun konsolu ve blockchain tabanlı taşınabilir bulut oyun konsolu gibi ürünler bulunmaktadır.',
      ques_title4: '4. DeepLink Protocol\'ün yenilikçi yönü nedir?',
      ques_text4: 'DeepLink, blockchain ve AI teknolojileri ile bulut oyun endüstrisinin karşılaştığı temel zorlukları çözmekte ve madencileri ve atıl GPU makinelerini token teşvik mekanizması ile çekmektedir. Ayrıca, kullanılmayan bant genişliğini çekerek bulut oyun endüstrisinin iki temel sorununu çözmektedir. AI teknolojisi, oyun grafiğini iyileştirerek kullanıcı deneyimini geliştirir.',
      ques_title5: '5. $DLC Token nedir?',
      ques_text5: '$DLC Token, DeepLink ekosisteminde tek ödeme aracıdır. Kullanıcılar, bulut oyun süresi satın almak, bulut oyun bilgisayarı kiralamak, lisans satın almak gibi işlemler için $DLC Token ile ödeme yapmalıdır.',
      ques_title6: "6. DeepLink Protocol'ün hedef müşterileri kimlerdir?",
      ques_text6_1: '1) AAA oyun şirketleri: AAA oyunları bulut oyunlarına dönüştürmeye yardımcı olur, böylece AAA oyunlar herhangi bir düşük kaliteli cihazda, hatta cep telefonlarında bile çalışabilir, AAA oyunlarının kullanıcı tabanını 10 kat artırır.',
      ques_text6_2: "2) İnternet kafeler ve eSpor otelleri: Geleneksel internet kafelerin modernizasyonuna yardımcı olur, onları bulut internet kafelere dönüştürür, donanım yatırımını %80'den fazla azaltır ve 4 yıl içinde net karı 3 kat artırır.",
      ques_text6_3: "3) Bulut oyun konsolu üreticileri: Üreticiler DeepLink Protocol'ü entegre ederek düşük kaliteli CPU yapılandırması ve yüksek kaliteli oyun ekranıyla AAA oyunları oynatabilir, oyuncuların donanım yatırımının %80'ini tasarruf eder.",
      ques_text6_4: "4) Bulut oyun taşınabilir konsolu üreticileri: Üreticiler DeepLink Protocol'ü entegre ederek taşınabilir konsol fiyatını geleneksel konsol fiyatının %30'una indirir ve oyun performansı geleneksel taşınabilir konsolun 5 katından fazladır.",
      ques_title7: "7. DeepLink Software'in hedef müşterileri kimlerdir?",
      ques_text7: "Dünya çapında 3 milyar potansiyel kişisel oyuncu, oyuncuların cep telefonları, düşük performanslı bilgisayarları veya Mac'leri ve televizyonları ile yüksek kaliteli AAA oyunları oynamalarını sağlar.",
      ques_title8: '8. Bir vesting dönemi var mı?',
      ques_text8: "Satın alınan DLC Token'ların %40'ı kilitli değil, %60'ı 31 Ağustos 2024 tarihinden itibaren 150 gün içinde her 30 günde %10 oranında kilitsiz hale gelecektir.",
      ques_title9: '9. $DLC nasıl satın alınır?',
      ques_text9: "Önce KYC'ye katılın, kişisel bilgilerinizi gönderin ve onaylandıktan sonra Public Sale başladığında $DLC satın alabilirsiniz.",
    },
    buy: {
      title: 'Nasıl satın alınır?',
      step1: 'Adım 1:',
      step1_text: 'Metamask cüzdanınızı veya Trust Wallet cüzdanınızı bağlayın',
      step2: 'Adım 2:',
      step2_text: 'İşlemi onaylayın. $DLC satın almak için USDT kullanabilirsiniz',
      step3: 'Adım 3:',
      step3_text: 'Açık satış bittikten sonra $DLC\'nizi talep edebilirsiniz',
      btn1: 'Yardıma ihtiyacınız var mı',
      btn2: '$DLC Satın Al',
    },
    potential: {
      title: 'Growth Potential', 
      text1_1: 'DePIN sektöründeki birçok token borsada listelendikten sonra piyasa değeri sürekli olarak artmaya devam etti.',
      text1_2: '$ 888',
      text1_3: '$ 2288',
      text1_4: '$ 5888',
      text1_5: '$ 12888',
      text2: "DeepLink Software, 1 milyardan fazla potansiyel kullanıcıya sahiptir ve bu, çok sayıda web2 kullanıcısını web3 dünyasına getirecektir. $DLC'nin potansiyel sahiplerinin sayısı 1 milyardan fazla kişiye ulaşmaktadır.",
      text3: "Dünya çapında 200.000'den fazla eSpor internet kafesi bulunmaktadır. Gelecekte, geleneksel internet kafelerin %50'den fazlası bulut internet kafelere dönüştürülecektir. Bulut internet kafe teknolojisinin geniş bir uygulama potansiyeli vardır ve her bulut internet kafe, ödeme yapmak için $DLC kullanmak zorunda kalacak, bu da $DLC'nin geniş çapta kullanılmasına yol açacaktır.",
      text4: "XBOX ve PS5'in satış rakamlarına dayanarak, blockchain tabanlı bulut oyun konsolları ve blockchain tabanlı taşınabilir bulut oyun konsolları satın alan kullanıcı sayısı 100 milyonu aşacaktır, bu da $DLC'ye büyük değer katacaktır."
    },
    report: {
      title: 'DeepLink Medya Raporları'
    },
    prompt: {
      title: 'Bilgilendirme Bildirimi',
      text1: 'DeepCloudX.PTE.LTD, deeplink.cloud web sitesini ("platform") işletmektedir.',
      text2: 'Bu platformu kullanarak, hizmet şartlarımızı, gizlilik politikamızı, çerez politikamızı ve DLC token satış sözleşmemizi kabul etmiş olursunuz. Yargı bölgenizde kripto para birimleri düzenlenmemiş olabilir. Kripto para birimlerinin değeri yükselebilir veya düşebilir. Kârlar, yargı bölgenizde geçerli olan sermaye kazancı vergisi veya diğer vergilerden etkilenebilir. Bu web sitesindeki hiçbir şey, satın alma, satma veya yatırım yapma teklifi veya tavsiyesi olarak yorumlanmamalıdır. Herhangi bir satın alma veya ilgili işlemin kişisel hedefleriniz, mali durumunuz ve risk toleransınıza göre sizin için uygun olup olmadığını belirlemek tamamen sizin sorumluluğunuzdadır.',
      text3: 'Yasal, vergi, sigorta veya iş tavsiyesi almak için güvenilir ve lisanslı hukuk profesyonellerine ve danışmanlara danışmalısınız. DLC, bu web sitesindeki herhangi bir kripto para biriminin performansını, sonuçlarını veya sermaye getirisini garanti etmez. Bu web sitesine ve herhangi bir sayfasına erişerek, DLC satış sözleşmesine tabi olmayı kabul etmiş olursunuz. Kripto para birimlerinin satın alınması risk taşır ve kısmi veya tam kayıpla sonuçlanabilir.'
    }
  },
  dialog1: {
    title: 'KYC Bilgilerini Gönder',
    text1: 'Kimlik bilgilerini yükle:',
    text2: 'Kimlik belgesi ile birlikte fotoğraf yükle:',
    text3: 'Kimlik kartı, pasaport veya ehliyetin ön yüzü',
    text4: 'Yüzünüz ve kimlik bilgileriniz net bir şekilde görünmelidir',
    text5: 'Satın almak istediğiniz DLC miktarı:',
    text6: 'Doğrulanmış cüzdan adresi:',
    text7: 'KYC doğrulamasını geçtikten sonra 1000 DLC ödülü alacaksınız ve Public Sale sırasında kilitlenen DLC de bu cüzdan adresine gönderilecektir',
    text7_1: 'Sadece bu adres KYC doğrulamasından sonra DLC satın almak için kullanılabilir, borsa adresi olamaz',
    text8: 'DBC zincirinde DLC cüzdan adresi nasıl oluşturulur?',
    text9: 'Veya',
    text10: 'E-posta adresinizi girin:',
    text11: 'Doğrulama kodunu al',
    text12: 'Doğrulama kodunu girin:',
    text13: '{secs} saniye sonra tekrar al',
    text14: '(Maksimum 20,000,000 DLC, Public Sale başladığında sadece KYC doğrulaması ile onaylanan miktar satın alınabilir)',

    success1: 'Doğrulama kodu gönderildi!',
    success2: 'Bilgiler başarıyla gönderildi, inceleme bekleniyor',
    error1: 'Bir resim dosyası seçmelisiniz!',
    error2: 'Resim dosyası boş olamaz!',
    error3: 'Kullanıcı adı boş olamaz!',
    error4: 'Cüzdan adresi boş olamaz!',
    error5: 'E-posta boş olamaz!',
    error6: 'Lütfen geçerli bir e-posta adresi girin!',
    error7: 'Doğrulama kodu boş olamaz!',
    error8: 'Doğrulama kodu gönderilemedi, lütfen daha sonra tekrar deneyin!',
    error9: 'Ekleme başarısız',
    error10: 'Yanlış doğrulama kodu, lütfen tekrar deneyin',
    error11: 'E-posta bilgilerini sorgulama başarısız',
    error12: 'Satın alma miktarı 20.000.000\'u geçemez',
    error13: 'Doğrulama kodu süresi doldu, lütfen tekrar alın',
    error14: 'Bilgiler başarıyla gönderildi, ancak onay e-postası gönderilemedi',
    error15: 'E-postayı almadıysanız, lütfen spam klasörünüzü kontrol edin',
    error16: 'Resim boyutu 5 MB\'ı geçemez',
    error17: 'Lütfen KYC doğrulama verilerini tekrar tekrar göndermeyin',
    tip1: '(Dostça hatırlatma: Kişisel kimlik bilgileri yalnızca KYC için kullanılacak ve başka amaçlar için kullanılmayacaktır)',
  },
  dialog2: {
    title: 'DLC Satın Al',
    text1: 'Satın alınacak DLC miktarı:',
    text2: 'En az 150.000 DLC satın almanız gerekmektedir',
    text3: 'Ödeme yapılacak kripto para birimini seçin:',
    text4: 'DBC zincirinde DLC cüzdan adresinizi girin:',
    text5: 'DLC\'lerin %40\'ı birkaç dakika içinde bu cüzdan adresine aktarılacak, kalan %60 DLC ise kilit süresi sona erdiğinde bu cüzdan adresine aktarılacak',
    text6: 'DBC zincirinde DLC cüzdan adresi nasıl oluşturulur?',
    text7: 'Veya',
    text8: 'Eşdeğer USDT:',
    text9: 'Ödeme yöntemini seçin:',
    text9_1: 'Bağlı olan cüzdan ile ödeme yapın',
    text9_2: 'QR kod ile ödeme yapın',
    error1: 'DLC miktarı boş olamaz',
    error2: 'Lütfen bir sayı girin',
    error3: 'Girilen sayı 50.000\'den büyük olmalıdır',
    error4: 'Cüzdan adresi boş olamaz',
    error5: 'Sipariş oluşturma başarısız',
    success1: 'Ödeme başarılı, DLC\'ler birkaç dakika içinde cüzdan adresinize aktarılacak, lütfen kontrol edin!',
    success2: 'Yönlendirme bağlantısı üzerinden ödeme başarılı, DLC\'ler birkaç dakika içinde cüzdan adresinize aktarılacak, lütfen kontrol edin!',
    error6: 'USDT miktarı boş olamaz',
    error7: 'USDT miktarı 150\'den az olamaz',
    error8: 'USDT miktarı 60.000\'den fazla olamaz',
    error9: 'Ödeme tutarı ile önceden girilen tutar uyuşmuyor, lütfen doğru olup olmadığını kontrol etmek için yöneticiye başvurun',
  },
  dialog3: {
    title: 'Hepsi Bir Arada Cihaz Tanıtımı',
    text1: '1. Bulut oyun hepsi bir arada cihaz nedir?',
    text2: 'Bulut oyun hepsi bir arada cihaz, geleneksel hepsi bir arada cihazlara kıyasla yüksek FPS yenileme hızına sahip bir ekran sunarak akıcı bir oyun deneyimi sağlar. HKC Grubu\'nun TIKEREN bulut oyun hepsi bir arada cihazı, DeepBrainChain + DeepLink teknolojisi ile geliştirilmiştir ve oyunların render ve hesaplamaları için yüksek performanslı uzaktan GPU\'lara gerçek zamanlı olarak bağlanabilir. Cihaz, yerleşik Windows sistemi ile donatılmış olup, normal ofis ve eğlence amaçlı kullanılabilir ve yüksek performanslı GPU\'nuzdan DeepLink üzerinden oyun akışı yapılabilir. Yüksek performanslı bir GPU\'ya sahip olmadığınızda, AAA oyunlarını oynamak için DeepLink üzerinden yüksek performanslı uzaktan GPU\'ya bağlanabilir ve saat başı belirli bir miktar DLC Token ödeyebilirsiniz.',
    text3: '2. TIKEREN cihazı tanıtımı',
    table: {
      th: {
        text1: 'Proje',
        text2: '27 inç',
        text3: '31.5 inç',
      },
      td1: {
        text1: 'Mode Type',
        text2: 'MA27H13QC1',
        text3: 'MA27H13QC1'
      },
      td2: {
        text1: 'Color Category',
        text2: 'Black',
        text3: 'Black'
      },
      td3: {
        text1: 'Display Size',
        text2: '27 inç',
        text3: '31.5 inç',
      },
      td4: {
        text1: 'Aspect Ratio',
        text2: 'Wide (16:9)',
        text3: 'Wide (16:9)'
      },
      td5: {
        text1: 'Panel Type',
        text2: 'IPS',
        text3: 'VA'
      },
      td6: {
        text1: 'Panel Resolution',
        text2: 'QHD 2560*1440',
        text3: 'QHD 2560*1440'
      },
      td7: {
        text1: 'Panel Refresh Rate',
        text2: '180Hz (Max)',
        text3: '170Hz(Max)'
      },
      td8: {
        text1: 'Responese Time',
        text2: '1mS(MPRT) GTG 1ms',
        text3: '1ms(MPRT) GTG 1ms'
      },
      td9: {
        text1: 'Color Gamut',
        text2: 'DCIP3 90%',
        text3: 'DCIP3 90%'
      },
      td10: {
        text1: 'Mainboard Solution',
        text2: 'Intel® N100 Chipset',
        text3: 'Intel® N100 Chipset'
      },
      td11: {
        text1: 'CPU/Cooler',
        text2: 'Intel N100 3.4GHz',
        text3: 'Intel N100 3.4GHz'
      },
      td12: {
        text1: 'Memory',
        text2: 'DDR4 8GB(Option Max 32G)',
        text3: 'DDR4 8GB(Option Max 32G)'
      },
      td13: {
        text1: 'Hard Disk',
        text2: 'SSD 128G(Option Max 1T)',
        text3: 'SSD 128G(Option Max 1T)'
      },
      td14: {
        text1: 'OS',
        text2: 'Windows 10/11(0ption)',
        text3: 'Windows 10/11(0ption)'
      },
      td15: {
        text1: 'GPU',
        text2: 'Intel UHD Graphics',
        text3: 'Intel UHD Graphics'
      },
      td16: {
        text1: 'Rear Interface',
        text2: '1*DC Power Connector，1*RJ45(2.5G)，4* USB 3.0，1*Audio jacks',
        text3: '1*DC Power Connector，1*HDMIN，1*HDMI OUT，1*RJ45(2.5G)，4* USB 3.0,1*Audio iacks'
      },
      td17: {
        text1: 'Side Interface',
        text2: 'USB 2.0x2，Power Button x1',
        text3: 'USB 2.0x2，Power Button x1'
      },
      td18: {
        text1: 'Wi-Fi',
        text2: '2.4G~5GHz(Wi-Fi5)，BT(4.2)',
        text3: '2.4G~5GHz(Wi-Fi5)，BT(4.2)'
      },
      td19: {
        text1: 'Audio',
        text2: 'Built-in Speakers*2',
        text3: 'Built-in Speakers*2'
      },
      td20: {
        text1: 'Base/Stand',
        text2: 'HAS:VESA',
        text3: 'HAS:VESA'
      },
      td21: {
        text1: 'Pivot',
        text2: 'Yukarı, aşağı, sola, sağa, 90° dönüş, yükseklik ayarı',
        text3: 'Yukarı, aşağı, sola, sağa, 90° dönüş, yükseklik ayarı',
      },
      td22: {
        text1: 'Power',
        text2: '90W',
        text3: '90W'
      },
      td23: {
        text1: 'Game Screen lmprovement',
        text2: 'Free Sync, G-Sync',
        text3: 'Free Sync, G-Sync'
      }
    },
    btn: 'Anladım'
  },
  dialog4: {
    title: 'Bulut Oyun Taşınabilir Konsol Tanıtımı',
    text1: '1. Bulut oyun taşınabilir konsolu nedir?',
    text2: 'Bulut oyun taşınabilir konsolu, geleneksel taşınabilir konsollardan, DeepLink\'in ultra düşük gecikmeli render teknolojisi ile geliştirilmiş olması nedeniyle farklıdır. Bu teknoloji sayesinde, bulut GPU sunucularına gerçek zamanlı bağlanarak yüksek performanslı oyun renderi yapabilir, bu da taşınabilir konsol maliyetini %70 oranında azaltır ve AAA oyunlarda akıcı bir oyun deneyimi sunar. Taşınabilir konsolda Google Play entegre edilmiştir ve Android oyunlarını indirebilir, ayrıca yüksek performanslı Windows GPU/PS/XBOX cihazlarınıza oyun akışı yapabilirsiniz. Yüksek performanslı bir GPU\'ya sahip olmadığınızda, DeepLink üzerinden uzaktaki yüksek performanslı bir GPU\'ya bağlanarak AAA oyunlarını oynayabilir ve saatlik belirli bir miktar DLC Token ödeyebilirsiniz.',
    text3: '2. Blokzincir tabanlı bulut oyun taşınabilir konsol tanıtımı',
    btn: 'Anladım'
  },
  dialog5: {
    title: 'Evde GPU Oyun Madenciliği Makinesi Tanıtımı',
    text1: '1. Evde GPU oyun madenciliği makinesi nedir?',
    text2: 'GPU oyun madenciliği makinesi NVIDIA 4070 Super GPU, Intel i7-13700F CPU, 32 GB RAM ve 2 TB SSD depolama alanı ile donatılmıştır. İçerisinde DeepLink madencilik yazılımı ve yönetim sistemi bulunmaktadır. Herkes bu makineyi evinde kurarak DLC ödülleri kazanabilir. Her yıl tüm oyun madenciliği makineleri için 1 milyar DLC Token ödül olarak dağıtılmaktadır, kullanıcılar makineyi oyun oynamak için kiralayıp kiralamadığına bakılmaksızın. GPU oyun madenciliği makinesi kiraya verildiğinde DLC ödülleri ve DBC kira geliri elde edilebilir. Kullanıcıların makineyi kiralamadığı zamanlarda ise diğer tokenlar madencilik yapılarak 24 saat boyunca gelir elde edilebilir.',
    text3: '2. Evde GPU oyun madenciliği makinesi gösterimi',
    text4: '3. Teknik özellikler',
    text5_1: 'With RTX4070 Super Graphics Card',
    text5_2: 'Core i7-13700F, 16 Cores, 24 Threads, Base 1.5/2.1 GHz, Max 4.1/5.1GHz;',
    text5_3: 'Graphics Card GeForce RTX4070 Supe12G. Support 3rd Gen Ray Tracing and 4th Tensor Core.',
    text5_4: 'RAM Dual DDR4, Max 64GB (32GB*2).',
    text5_5: 'Hard Drive Ports One M2 2280 NVME SSD, and support to add double 2.5" SATA hard drive.',
    text5_6: 'Ports 4*USB 3.2, 4* USB 2.0, 3*DisplayPort, 1*HDMI, 2*LAN, 1*Optical, 1*Audio, 1*DC-IN, 2*WiFi ports.',
    text5_7: 'Operating System Preinstall with Windows 11 Pro.',
    btn: 'Anladım'
  }
}